export const isIos = () =>
  typeof navigator !== 'undefined' && /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
